import { cn } from "@/lib/utils";
import {
  useContentfulInspectorMode,
  useContentfulLiveUpdates,
} from "@contentful/live-preview/react";
import Link from "next/link";
import {
  BUTTON_DISABLED_CLASS,
  BUTTON_SUBTYPE_CLASS,
  BUTTON_TYPE_CLASS,
  ButtonPropsModel,
} from "./Button.model";

export default function Button(props: ButtonPropsModel) {
  const {
    className,
    primary,
    type,
    actionType,
    disabled,
    fullWidth,
    fullHeight = true,
    content,
    onClick,
  } = props;

  let inspectorProps;
  let liveData = content;
  let contentfulProps;
  if (content?.sys?.id) {
    inspectorProps = useContentfulInspectorMode({
      entryId: content.sys.id,
    });
    contentfulProps = inspectorProps({ fieldId: "text" });
    liveData = useContentfulLiveUpdates(content);
  }

  const { text, url } = liveData;

  const classnames = cn(
    "transition-all duration-300 no-underline",
    className,
    primary ? BUTTON_TYPE_CLASS.PRIMARY : BUTTON_TYPE_CLASS.SECONDARY,
    !disabled &&
      (type
        ? type
        : primary
          ? BUTTON_SUBTYPE_CLASS.PRIMARY_BLACK
          : BUTTON_SUBTYPE_CLASS.SECONDARY_BLACK),
    disabled && "pointer-events-none",
    disabled && primary && BUTTON_DISABLED_CLASS.PRIMARY,
    disabled && !primary && BUTTON_DISABLED_CLASS.SECONDARY,
    fullWidth && "w-full",
  );

  return (
    <div className={cn("btn text-ll flex items-center", fullHeight && "h-btn")}>
      {url ? (
        <Link
          {...contentfulProps}
          className={classnames}
          href={url}
          scroll={!onClick}
          aria-disabled={disabled}
          tabIndex={disabled ? -1 : undefined}
          onClick={onClick}
        >
          {text}
        </Link>
      ) : (
        <button
          {...contentfulProps}
          className={classnames}
          type={actionType}
          disabled={disabled}
          onClick={onClick}
          aria-label={text}
        >
          {text}
        </button>
      )}
    </div>
  );
}
